<template>
  <svg
    class="icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M8.2481 10.3124C8.2481 10.0027 7.99466 9.75 7.68573 9.75H4.87388V12.7493C4.87388 12.7493 4.53796 12.7493 4.12405 12.7493C3.71015 12.7493 3.37422 12.7493 3.37422 12.7493V9.75H0.562371C0.252692 9.75 0 10.0027 0 10.3124V17.4357C0 17.7454 0.252692 17.9981 0.562371 17.9981H7.68573C7.99466 17.9981 8.2481 17.7454 8.2481 17.4357V10.3124Z" />
    <path fill="currentColor" d="M18 10.3124C18 10.0027 17.7466 9.75 17.4376 9.75H14.6258V12.7493C14.6258 12.7493 14.2898 12.7493 13.8759 12.7493C13.462 12.7493 13.1261 12.7493 13.1261 12.7493V9.75L10.3143 9.75C10.0046 9.75 9.75189 10.0027 9.75189 10.3124V17.4357C9.75189 17.7454 10.0046 17.9981 10.3143 17.9981H17.4376C17.7466 17.9981 18 17.7454 18 17.4357V10.3124Z" />
    <path fill="currentColor" d="M13.1179 0.562371C13.1179 0.253442 12.8645 0 12.5556 0H9.74372V2.99931C9.59376 2.99931 9.4078 2.99931 8.99389 2.99931C8.57999 2.99931 8.24407 2.99931 8.24407 2.99931V0H5.43221C5.12253 0 4.86984 0.253442 4.86984 0.562371V7.68573C4.86984 7.99541 5.12253 8.2481 5.43221 8.2481H12.5556C12.8645 8.2481 13.1179 7.99541 13.1179 7.68573V0.562371Z" />
  </svg>
</template>

<script>
export default {
  name: 'Inventory',
};
</script>
